import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import { firebaseConfig, prodFirebaseConfig } from "./firebase-config";
import { unMachine } from "./filters";
import VueAnnouncer from "vue-announcer";
import "firebase/firestore";
import "firebase/firebase-database";
import { mapMutations } from "vuex";

Vue.config.productionTip = false;

// Filters.
Vue.filter("unMachine", unMachine);

// Vue announcer.
Vue.use(VueAnnouncer, {}, router);

// Main vue instance.
new Vue({
  router,
  store,

  methods: {
    ...mapMutations(["setDB", "setAnalytics"]),
  },

  async created() {
    // Update DB URL if we are local.
    if (location.hostname === "localhost") {
      firebaseConfig.databaseURL =
        "http://localhost:9000/?ns=bacpac-a46ca-default-rtdb";
    }

    // Init firebase based on environment.
    if (
      location.hostname.includes("localhost") ||
      location.hostname.includes("bacpac")
    ) {
      firebase.initializeApp(firebaseConfig);
    } else {
      firebase.initializeApp(prodFirebaseConfig);
    }

    // Set auth emulator if we're local.
    if (window.location.href.includes("localhost")) {
      firebase.auth().useEmulator("http://localhost:9099");
    }

    // Init firestore db.
    const db = firebase.firestore();

    // Use the emulator if we're local.
    if (location.hostname === "localhost") {
      db.useEmulator("localhost", 8080);
    }

    // Set DB store.
    this.setDB(db);

    // Enable data persistence.
    firebase.firestore().enablePersistence();

    firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) {
        window.location.href = "/?logout=true";
      } else {
        // Init analytics and set user ID.
        this.setAnalytics(firebase.analytics().setUserId(user.uid));

        // Check to see if you have a fitbit access token in the URL.
        const params = new URLSearchParams(window.location.hash.substr(1));

        // React if we have a fitbit access token in the URL.
        if (params.has("access_token")) {
          const token = params.get("access_token");

          const headers = {
            Authorization: `Bearer ${token}`,
          };

          // Store access token in local storage.
          localStorage.setItem("fitbit_token", token);

          // Get user profile.
          const profile = await fetch(
            "https://api.fitbit.com/1/user/-/profile.json",
            { headers }
          );

          const profileData = await profile.json();

          // Init realtime database.
          const realtimeDB = firebase.database();

          // Set db emulator if we're local.
          if (location.hostname === "localhost") {
            realtimeDB.useEmulator("localhost", 9000);
          }

          // Store access token in DB.
          await realtimeDB.ref(`/fitbit/${profileData.user.encodedId}`).set({
            token,
            uid: user.uid,
          });

          // Send back to the steps page.
          this.$router.push("/steps");
        }
      }
    });
  },

  render: (h) => h(App),
}).$mount("#app");
